// extracted by mini-css-extract-plugin
export default {"wrapper":"dS-z","ratingContainer":"eS-z","ratingValue":"fS-z","starSprite":"gS-z","ratingLabel":"hS-z","error":"iS-z","errorBox":"jS-z"};